export const LoginBackgroundType = {
  image: "image",
  color: "color",
} as const;

export type LoginBackgroundTypeValue =
  (typeof LoginBackgroundType)[keyof typeof LoginBackgroundType];

export default LoginBackgroundType;
